import { createTheme } from "@mui/material/styles";
const { palette } = createTheme();
const { augmentColor } = palette;
const createColor = (mainColor) => augmentColor({ color: { main: mainColor } });

export const MUI_THEME = createTheme({
  typography: {
    fontSize: 15,
    fontFamily: "Poppins, light[300], sans-serif",
  },
  button: {
    fontFamily: "Poppins, light[300], sans-serif",
  },
  palette: {
    default: createColor("#f5f5f5"),
    grey: createColor("#444444"),
    lightBlue: createColor("#3c8dbc"),
    hoverlightBlue: createColor("#60a8d0"),
    turquoiseBox: createColor("#00c0ef"),
    lightGrey: createColor("#f4f4f4"),
    warning: createColor("#F39C12"),
    success: createColor("#FFD769"),
    lightDanger: createColor("#D87A68"),
  },
  components: {
    MuiDataGrid: {
      styleOverrides: {
        root: {
          backgroundColor: "white",
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          backgroundColor: "white",
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: "white",
        },
      },
    },
  },
});
